import { v4 as uuidv4 } from 'uuid'; 

export const addToken = (token) => ({
    type: 'ADD_TOKEN',
    id: uuidv4(),
    token,
});